import { createAction } from 'redux-actions';
import types from './types';

export default createAction(types.SET_FISCALYEAR);




// WEBPACK FOOTER //
// ./src/infraMonitor/fiscalyear/actions.js